import ArticleParagraph from "components/ArticleParagraph";
import { useGetArticleList } from "hooks";
import RootLayout from "layouts/RootLayout";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {getInfoTitles} from "../utils/infoTitleHelper";

const Article = () => {
  const location = useLocation();
  const hash = location.hash || '';
  const { articleId } = useParams();
  const navigate = useNavigate();
  const { articleList } = useGetArticleList(hash);
  const title = getInfoTitles(hash);

  const article = articleList.find(a => a.id.toString() === articleId);

  const handleGoBack = () => {
    navigate(-1);
  };

  if (articleList.length === 0) return null;

  return (
    <RootLayout title={title}>

      <div className="px-8 pt-7">
        <div
            className="pb-4 flex items-center flex-nowrap"
            onClick={handleGoBack}
        >
          <span className="mr-2">
            <img src="/img/vector.svg" alt=""/>
          </span>
          <span className="text-xl text-[#555555]">回上頁</span>
        </div>
        <article className="pb-16">
          <header className="py-2.5 border-b-[1px] border-b-[##D0D0D0]">
            <h1 className="text-2xl mb-2">{article.title}</h1>
            <time className="text-[#00000099]">{article.date}</time>
          </header>
          <div className="mt-2 space-y-6 text-[#000000E6] text-lg tracking-wider">
            {article.paragraph.map(p => (
                <ArticleParagraph {...p} />
            ))}
          </div>
        </article>
        <div
            className="pb-4 flex items-center flex-nowrap"
            onClick={handleGoBack}
        >
          <span className="mr-2">
            <img src="/img/vector.svg" alt=""/>
          </span>
          <span className="text-xl text-[#555555]">回上頁</span>
        </div>
      </div>
    </RootLayout>
  );
};

export default Article;
